module.exports = __webpack_public_path__ + "img/SkillsTown-Logo.f38e0dbf.png";